<template>
  <div class="dialog_container">
    <el-dialog
      :title="name"
      :visible="show"
      @close="dialogClose"
      class="tanchu_dialog"
      top="10vh"
      append-to-body
    >
      <img width="100%" :src="path" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "previewImage",
  data() {
    return {};
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    path: {
      type: String,
      default: '',
    },
  },
  created() {},
  methods: {
    dialogClose() {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/css/dialog";
</style>



// WEBPACK FOOTER //
// src/components/previewImage.vue